<script setup>
const { $isMobile } = useNuxtApp();

definePageMeta({
	"m-showNavBar": true,
	"m-showFooter": true,
	"pc-showNavBar": true,
	"pc-showFooter": true,
	breadcrumbName: "common.breadcrumb.onlineTest",
});

useHead({
	title: "先知命局 - 可靠的免费線上算命，專業命理大師為您解讀",
	meta: [
		{ name: "keywords", content: "線上算命，免费線上算命" },
		{
			name: "description",
			content:
				"提供專業的免费線上算命服務，透過真人大師的精准測試，為您解析八字、紫微斗數、星座等多種命理，幫助您洞察未來，解決事業、感情、財富等各方面的問題。",
		},
	],
});

// 动态导入组件（代码分割）
const Component = $isMobile
	? defineAsyncComponent(() => import("@variants/seer/onlinecs/m/index.vue"))
	: defineAsyncComponent(() => import("@variants/seer/onlinecs/pc/index.vue"));
</script>

<template>
	<Component />
</template>
